import React from "react";
import PropTypes from "prop-types";
import { getManeTranscriptForACMG } from "../../../transcripts/helpers";
import GeneWithRefGenomeLink from "../../../../../../common/helpers/GeneWithRefGenomeLink";

const TranscriptOptionLabel = ({
  varsomeHost,
  refGenome,
  item,
  refseqTranscriptsOptions,
  ensemblTranscriptsOptions,
}) => {
  return (
    <>
      <span>
        <a
          href={`${varsomeHost}/transcript/${refGenome}/${item.name}`}
          target="_blank"
        >
          {item.name}
        </a>
        {`${
          item.canonical &&
          !getManeTranscriptForACMG(
            item.name,
            refseqTranscriptsOptions?.[0]?.items,
            ensemblTranscriptsOptions?.[0]?.items
          )
            ? ", canonical, "
            : ", "
        }${getManeTranscriptForACMG(
          item.name,
          refseqTranscriptsOptions?.[0]?.items,
          ensemblTranscriptsOptions?.[0]?.items
        )}protein length ${(item.total_coding_length / 3).toFixed()}${
          item.gene_symbol && item.gene_symbol != null ? ", gene " : ""
        }`}
        <GeneWithRefGenomeLink
          href={`${varsomeHost}/gene/${item.gene_symbol}`}
          target="_blank"
        >
          {item.gene_symbol}
        </GeneWithRefGenomeLink>
        {`, ${
          item.coding_impact !== "non-coding"
            ? `${item.coding_impact} variant`
            : ""
        }`}
      </span>
    </>
  );
};

TranscriptOptionLabel.propTypes = {
  varsomeHost: PropTypes.string.isRequired,
  refGenome: PropTypes.string.isRequired,
  item: PropTypes.shape({
    coding_impact: PropTypes.string,
    gene_symbol: PropTypes.string,
    name: PropTypes.string,
    canonical: PropTypes.bool,
    total_coding_length: PropTypes.number,
  }).isRequired,
  refseqTranscriptsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ).isRequired,
  ensemblTranscriptsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ).isRequired,
};

export default TranscriptOptionLabel;
